import { Input, Label } from './ui/Input';

function TextArea({ label, value, onChange, rows = 3, className = '' }) {
  return (
    <div className={className}>
      {label && <Label>{label}</Label>}
      <textarea
        value={value}
        onChange={onChange}
        rows={rows}
        className="w-full rounded-lg border border-border bg-input px-3 py-2.5 text-sm text-text placeholder:text-muted focus:border-primary focus:outline-none focus:ring-2 focus:ring-primary/20"
      />
    </div>
  );
}

export function InvoiceIssuerForm({ labels, issuer, onChange, compact = false }) {
  const set = (key) => (e) => onChange({ ...issuer, [key]: e.target.value });

  return (
    <div className={compact ? 'space-y-3' : 'space-y-4'}>
      <Input label={labels.invoiceIssuerName} value={issuer.issuerName} onChange={set('issuerName')} />
      <TextArea label={labels.invoiceIssuerAddress} value={issuer.issuerAddress} onChange={set('issuerAddress')} />
      <Input label={labels.invoiceIssuerEmail} value={issuer.issuerEmail} onChange={set('issuerEmail')} />
      <Input label={labels.invoiceIssuerEmail2} value={issuer.issuerEmail2} onChange={set('issuerEmail2')} />
      <Input label={labels.invoiceIssuerPhone} value={issuer.issuerPhone} onChange={set('issuerPhone')} />
      <Input label={labels.invoiceUpiId} value={issuer.upiId} onChange={set('upiId')} />
      <TextArea label={labels.invoiceBankDetails} value={issuer.bankDetails} onChange={set('bankDetails')} rows={2} />
      <Input
        label={labels.invoiceRatePerClass}
        type="number"
        min={1}
        step={1}
        inputMode="numeric"
        value={issuer.pricePerClassYear}
        onChange={set('pricePerClassYear')}
      />
      <Input
        label={labels.invoiceLineDescription}
        value={issuer.lineItemDescription}
        onChange={set('lineItemDescription')}
      />
      <Input label={labels.invoicePaymentTerms} value={issuer.paymentTerms} onChange={set('paymentTerms')} />
      <TextArea label={labels.invoiceFooterNote} value={issuer.footerNote} onChange={set('footerNote')} rows={2} />
    </div>
  );
}
